<template>
  <app-fieldset title="Leverdatum &amp; datum geldig tot">
    <div>
      <expected-delivery-date
        v-if="showDeliveryDate"
        ref="expectedDeliveryDateBlock"
        :is-purchase-order="true"
        :disabled="disable"
      />
    </div>
    <div>
      <do-not-deliver-before
        v-if="showDoNotDeliverBeforeDate"
        :is-purchase-order="true"
        :disabled="disable"
      />
    </div>
  </app-fieldset>
</template>

<script>
import moment from 'moment'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import ExpectedDeliveryDate from '@/components/generic/presentational/molecules/expectedDeliveryDate/ExpectedDeliveryDate.vue'
import DoNotDeliverBefore from '@/components/generic/presentational/molecules/doNotDeliverBefore/DoNotDeliverBefore.vue'

export default {
  components: {
    AppFieldset,
    ExpectedDeliveryDate,
    DoNotDeliverBefore,
  },
  props: {
    showDoNotDeliverBeforeDate: {
      type: Boolean,
      default: true,
    },
    showDeliveryDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      minDate: moment(),
      disable: false,
    }
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .fields {
    grid-template-columns: repeat(2, 1fr);
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 0.5em;

    div {
      display: flex;
      align-items: center;
      flex: 1;

      div {
        display: block;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
